import { getConfig } from './config';

export interface Override {
  testerAlias: string;
  addedTags: string[];
  removedTags: string[];
  includeInScheduling: boolean;
  priorityScore: number;
}

async function apiCall<T>(idToken: string, method: string, path: string, body?: unknown): Promise<T> {
  const config = await getConfig();
  const resp = await fetch(config.apiUrl + path, {
    method,
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  return resp.json();
}

export async function getOverrides(idToken: string): Promise<Override[]> {
  const data = await apiCall<{ overrides?: Override[] }>(idToken, 'GET', '/overrides');
  return data.overrides ?? [];
}

export async function updateOverride(
  idToken: string,
  alias: string,
  body: Omit<Override, 'testerAlias'>,
): Promise<void> {
  await apiCall(idToken, 'PUT', `/overrides/${encodeURIComponent(alias)}`, body);
}
